import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';

import fetch from './fetch';
import { mapSelectOptions } from './helpers';

function getCityList() {
  const { cb, key } = fetch();

  const { data, isLoading, isSuccess, isError, refetch, isRefetching } = useQuery(key, cb);

  const cityList = data?.kota;
  const citySelectOptions = useMemo(() => mapSelectOptions(cityList), [cityList]);

  return {
    data,
    isLoading,
    isSuccess,
    isError,
    refetch,
    isRefetching,
    cityList,
    citySelectOptions,
  };
}

export default getCityList;
